import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import compose from 'recompose/compose';

const ViewSwitchSection = (props) => props.switchCases[props.switchValue] || [];

ViewSwitchSection.propTypes = {
  switchValue: PropTypes.any.isRequired,
  switchCases: PropTypes.objectOf(PropTypes.element).isRequired
};

const mapState = (state, ownProps) => {
  return {
    switchValue: ownProps.section.viewSwitch(ownProps.formProxy)
  }
};

export default compose(
  connect(mapState, null)
)(ViewSwitchSection);



// WEBPACK FOOTER //
// ./public/components/forms/ViewSwitchSection.jsx